<template>
  <app-layout ref="refAppLayout">
    <template #main-content>
      <main id="content" class="l-main p-top">
        <div v-if="isMissionPageLoading">
          <loading-page></loading-page>
        </div>
        <div v-else class="l-main__inner">
          <div class="p-top-contentBody">
            <button-group :licensed-subject="topStore.carouselSubject"
                          :current-mission="topStore.currentMission"
                          name="S2-2-subject-btn"
                          @click="isSelected">
            </button-group>
            <div class="p-top-missionsContainer">
              <section v-for="(subj, index) in topStore.carouselSubject" :key="index" :id="subjectFieldMap[subj.field]+'_slide'"
                       class="p-top-slideContent" :style="missionDisplay(subjectFieldMap[subj.field])">
                <div class="p-top-misssion-name">
                  <div :class="{'icon':true, ['icon--'+subjectFieldMap[subj.field]]:true}" style="width: fit-content">
                    <img :src="`${subjectImage(subjectFieldMap[subj.field])}`" alt="">
                  </div>
                  <h1 class="heading">{{ subj.field }}のミッション</h1>
                </div>
                <div class="p-top-missions">
                  <div class="p-top-missions__body">
                    <carousel :swiper-id-mission="subjectFieldMap[subj.field]">
                      <li v-for="(card, n) of missionCard(subj.field)" :key="n" :ref="(el) => {refMission[`${index}_${n}`] = el}">
                        <!-- リリース1は「次のミッション待っててね」のみ、「ミッション完了」はリリース1対象外-->
                        <div v-if="!card" class="p-top-missionListBlock p-top-missionListBlock--typeWait">
                          <div class="p-top-missionListBlock__inner">
                            <div class="p-top-missionListBlock__body">
                              <p class="otherText">次のミッション<br>待っててね！</p>
                            </div>
                          </div>
                        </div>
                        <div v-else
                            :class="{'p-top-missionListBlock':true,
                            ['p-top-missionListBlock--type'+ missionKindMap[card.mission_kind][0]]:true,
                            ['-'+subjectMap[subj.name]]:true
                                     }">
                          <div v-if="workStore.isMissionQuestion && isMissionCardLoading[`${index}_${n}`]" class="loading-overlay">
                            <div class="loading-spinner"></div>
                          </div>
                          <div class="p-top-missionListBlock__inner">
                            <div class="p-top-missionListBlock__header">
                              <div class="p-top-missionListBlock__header-title">
                                <p class="label">{{missionKindMap[card.mission_kind][1]}}</p>
                                <p class="labelSub">{{missionKindMap[card.mission_kind][2]}}</p>
                              </div>
                              <div class="p-top-missionListBlock__header-progress">
                                <donut-graph :ref="(el) => {refDonutGraph[`${index}_${n}`] = el}"
                                             :clear-mission-num="clearMissionNumber(card.question_set.id)"
                                             :total-mission-num="totalMissionNumber(card.question_set.id)"
                                             :graph-id="index+'_'+n"></donut-graph>
                              </div>
                              <div v-if="generateReloadButton(card,subj)" class="p-top-missionListBlock__header-reload">
                                <a class="c-button-reload" @click="reloadMission(card.uuid, card.mission_kind, `${index}_${n}`)" name="S2-2-reload-btn"></a>
                              </div>
                            </div>
                            <div class="p-top-missionListBlock__body">
                              <div class="title">
                                <span class="c-parts-label -left">{{sectionInfo(card).section_sort_order}}</span>
                                <markdown-view :rawText="sectionInfo(card).section_title" :souruby="accountStore.isSouruby"></markdown-view>
                              </div>
                              <div class="status">
                                <span v-if="isInterruptionData(card)" class="c-parts-frame -small -interrupt">中断した学習</span>
                              </div>
                              <div class="unit">
                                <div class="type">
                                  <span v-if="sectionInfo(card).display_name" :class="{'c-parts-frame':true, '-application':sectionInfo(card).display_name == '応用問題'}">{{sectionInfo(card).display_name[0]}}</span>
                                </div>
                                <markdown-view :rawText="card.question_set.title" :souruby="accountStore.isSouruby"></markdown-view>
                              </div>
                              <div class="c-parts-text-page -mission" v-if="card.question_set.textbook_page_range!==''">P {{card.question_set.textbook_page_range}}</div>
                              <div class="c-parts-last-learning -mission">
                                <p v-if="card.mission_kind !== missionKindSort.NEW" class="c-parts-last-learning__history">
                                  <span class="label">前回の学習</span><span class="date"><span
                                    class="num">{{previousStudyMonth(card.question_set.id)}}</span>月
                                  <span class="num">{{previousStudyDay(card.question_set.id)}}</span>日</span>
                                </p>
                                <three-stars :ref="(el) => { refMissionCarouselStar[`${index}_${n}`] = el }"
                                             :number-of-stars="numberOfStars(card.question_set.id)"></three-stars>
                              </div>
                              <div class="button">
                                <a v-if="isInterruptionData(card)" class="c-button-blue -small" @click="openInterruptionModal(card, `${index}_${n}`)">
                                  <span class="label -refresh">学習を再開</span>
                                </a>
                                <button-blue v-else :small="true" @click="openQuestionModal(card, `${index}_${n}`)" name="S2-2-challenge-btn">チャレンジ</button-blue>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </carousel>
                  </div>
                </div>
                <div class="p-top-missions-bgnav">
                  <div class="p-top-missions-bgnav__circle p-top-missions-bgnav__circle--prev">
                  </div>
                  <div class="p-top-missions-bgnav__circle p-top-missions-bgnav__circle--next">
                  </div>
                </div>
                <div class="p-top-missions-nav">
                  <a class="p-top-missions-nav__circle p-top-missions-nav__circle--prev"
                     @click="moveCarousel(subj,'prev')">
                  </a>
                  <a class="p-top-missions-nav__circle p-top-missions-nav__circle--next"
                     @click="moveCarousel(subj,'next')">
                  </a>
                </div>
              </section>
            </div>
          </div>
        </div>
        <popup-modal v-model="interruptionModal" @close-layer="interruptionModal = false" @close="interruptionModal = false" name="interruption-btn">
          <template #main>
            <div class="c-popup-body__head">
              <p class="c-popup-body__head-title">
                中断した学習を再開しますか？
              </p>
            </div>
            <div class="c-popup-body__titleBox">
              <div class="c-popup-body__titleBox-logout">
                中断した学習の続きから再開することができます。
              </div>
            </div>
          </template>
          <template #footer>
            <div class="c-button -col2">
              <a @click="openQuestionModal(interruptionFlag.card, interruptionFlag.card_id)" class="c-button-white -medium -font-large" name="S2-2-start-from-beginning-btn">
                <span class="label">最初から学習</span>
              </a>
              <button-blue @click="startInterruptDataLearning()" :medium="true" :label-normal="true" name="S2-2-resume-from-last-btn">続きから再開</button-blue>
            </div>
          </template>
        </popup-modal>
        <popup-modal v-model="questionModal" @close="closeModal()" @close-layer="closeLayer()" :subject="globalNavigationStore.selectedColor" name="close-btn">
          <template #main>
            <div :class="{'c-popup-body__chapter':true,
                }">
              <span class="c-parts-label -large">{{ sectionLabel }}</span>
              <div class="c-popup-body__chapter-title">
                <markdown-view :rawText="sectionTitle" :souruby="accountStore.isSouruby"></markdown-view>
              </div>
            </div>
            <div class="c-popup-body__titleBox">
              <div class="c-popup-body__titleBox-title">
                <div class="titleBlock">
                  <div class="c-parts-frame-wrapper">
                    <span v-if="displayName" :class="{'c-parts-frame -question':true, '-application':displayName == '応用問題'}">{{displayName}}</span>
                  </div>
                  <div class="title" v-if="selectedQuestionSet">
                    <markdown-view :rawText="selectedQuestionSet.title" :souruby="accountStore.isSouruby"></markdown-view>
                  </div>
                  <div class="count">全<span class="label">{{ workStore.questions.length }}</span>問</div>
                </div>
              </div>
              <div class="c-popup-body__titleBox-body">
                <div class="c-parts-text-page" v-if="selectedQuestionSet && selectedQuestionSet.textbook_page_range!==''">P
                  {{ selectedQuestionSet.textbook_page_range }}
                </div>
                <div class="empty" v-else></div>
                <div class="c-parts-last-learning -popup">
                  <p class="c-parts-last-learning__history" v-if="stars>0">
                    <span class="label">前回の学習</span>
                    <span class="date">
                        <span class="num">{{ parseInt(previousStudyMonth(selectedQuestionSet.id)) }}</span>月
                        <span class="num">{{ parseInt(previousStudyDay(selectedQuestionSet.id)) }}</span>日
                    </span>
                  </p>
                  <three-stars :number-of-stars="stars"></three-stars>
                </div>
              </div>
            </div>
          </template>
          <template #footer>
            <button-blue :full="true" @click="startLearning()" :disabled="processing || isAnimationStarCount" name="mission-start-learning-btn">始める
            </button-blue>
          </template>
        </popup-modal>
      </main>
    </template>
  </app-layout>
</template>

<script setup lang="ts">
  import {ref, watch, onMounted, onUnmounted, computed} from 'vue';
  import {useRoute, useRouter} from "vue-router";
  import {event} from "vue-gtag";
  import AppLayout from "@/components/student/AppLayout.vue";
  import {SOCIETY_SUBJECT_FIELD, SUBJECT_MAP, SUBJECTFIELD_MAP, SUBJECTFIELD_ORDER_MAP} from "@/consts/subject";
  import {SUBJECTFIELD_ID_IMAGE_MAP} from "@/consts/images";
  import {MISSIONKIND_MAP, MISSIONKIND_SORT} from "@/consts/mission";
  import AudioPlayer from '@/consts/sounds';
  import {nestedItems} from "@/util/collect-nested-data";
  import { isEnvCaptureGoogleAnalyticsEvents } from "@/util/env"
  import * as Sentry from "@sentry/browser";
  import {findSectionByQuestionSetId} from "@/util/extract-section-data"
  import { useAccountStore } from '@/store/student/account_store';
  import { useWorkStore } from '@/store/student/work_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import { useTopStore } from '@/store/student/top_store';
  import { useHomeworkStore } from '@/store/student/homework_store';
  import { saveInitialStudyBreakData } from '@/util/study_break_data';
  import local_time from '@/util/datetime';
  import { getLatestBreakDataVersion } from '@/consts/break_data_version'


  const audioPlayer = AudioPlayer.getInstance()
  const route = useRoute()
  const router = useRouter()
  const accountStore = useAccountStore()
  const workStore = useWorkStore()
  const topStore = useTopStore()
  const globalNavigationStore = useGlobalNavigationStore()
  const refAppLayout = ref(null)
  const refDonutGraph = ref([])
  const refMission = ref([])
  const refMissionCarouselStar = ref([])
  const subjectMap = SUBJECT_MAP
  const subjectFieldMap = SUBJECTFIELD_MAP
  const questionSet  = ref(null)
  const selectedQuestionSet = ref(null)
  const selectedSection = ref(null)
  const questionModal = ref(false)
  const interruptionModal = ref(false)
  const interruptionFlag = ref({
    card: null,
    card_id: null
  })
  const stars = ref(0)
  const shakaiSubMap = ref(["chiri", "rekishi", "komin"])
  const processing = ref(false)
  const isAnimationStarCount = ref(false)
  const refresh_timer = ref([])
  const learningStartPage = {
    name: route.name,
    path: route.path,
    params: route.params,
  }
  const isMissionCardLoading = ref({});
  const isMissionPageLoading = ref(true);

  onMounted(() =>{
    // 内側のスクロールがあるS3-7,8,9画面から戻る時は外側(body)スクロール禁止するクラスを削除する（ipadの不具合）
    let body_tag = document.getElementsByTagName('body')[0]
    body_tag.classList.remove("unscrollable")

    document.title = "ミッション一覧"
    workStore.saveLearningStartPage(null)
    globalNavigationStore.saveSelectedMenu("mission")
    useHomeworkStore().saveIsHomework(false)
    // NFR-4440 ワーク/ワークAPIの値が取得したら画面レンダリングで必要な処理を行う。
    if(workStore.isValidWorks){
      renderingData()
    }
    window.addEventListener('popstate', browserBackHandler);
  })

  function browserBackHandler(event:any) {
    // prevent browser back button action for learning state
    if(event.currentTarget.location.pathname == "/student/question" ||
       event.currentTarget.location.pathname == "/student/answer" ||
       event.currentTarget.location.pathname == "/student/judge"){
      window.history.forward()
    }else{
      // make selectedWork empty avoid flicking work page
      workStore.saveSelectedWork([])
      window.location.reload()
    }
  }
  function animateDonutGraph(id, number_of_star) {
    return new Promise((resolve, reject) => {
      if(refDonutGraph.value[id]) {
        refDonutGraph.value[id].animate(id).then(() => {
          refAppLayout.value.numberOfStar = number_of_star
          refMissionCarouselStar.value[id].animate(number_of_star)
          if(accountStore.isSoundEnabled){audioPlayer.starSound().play()}
          animateStamp(id)
          if (refAppLayout.value) {
            refAppLayout.value.refGlobalNavigation.animateClearCount(2500).then(result => {
              if (refAppLayout.value) {
                refAppLayout.value.refGlobalNavigation.animateStarCount(2800).then(() => {
                  isAnimationStarCount.value = false
                  resolve(true)
                })
              }
            })
          }
        })
      }
    })
  }

  function animateStamp(id) {
    let clearMissionCard = refMission.value[id]
    document.body.insertAdjacentHTML('afterend', '<span class="clearStar"></span>');
    clearMissionCard.classList.add('clear')
    clearMissionCard.insertAdjacentHTML('afterbegin', '<span class="stamp"></span>')
    let timer = setTimeout(() => {
      if(accountStore.isSoundEnabled){audioPlayer.stampSound().play()}
      clearMissionCard.classList.add('is-clear');
    }, 2000);
    refresh_timer.value.push(timer)
    timer = setTimeout(() => {
      animateStarMove(clearMissionCard)
    }, 4200);
    refresh_timer.value.push(timer)
    timer = setTimeout(() => {
      if(accountStore.isSoundEnabled){audioPlayer.shootingStarSound().play()}
      clearMissionCard.classList.add('is-next');
    }, 5200);
    refresh_timer.value.push(timer)
    timer = setTimeout(() => {
      clearMissionCard.classList = ""
    }, 6500)
    refresh_timer.value.push(timer)
  }

  function animateStarMove(clearMissionCard){
    let target = document.querySelector(".statusNav__list__item--star"); //グローバルナビゲーションの獲得スター数エリア
    let clearStar = document.querySelector(".clearStar");

    //位置を取得
    let targetRect = target.getBoundingClientRect();
    let clearMissionCardRect = clearMissionCard.getBoundingClientRect();
    let targetPosPy = targetRect.top + window.pageYOffset;
    let targetPosPx = targetRect.left + window.pageXOffset + (target.clientWidth / 2);
    let clearMissionCardPosPy = clearMissionCardRect.top + window.pageYOffset + (clearMissionCard.clientHeight / 3);
    let clearMissionCardPosPx = clearMissionCardRect.left + window.pageXOffset + (clearMissionCard.clientWidth / 2);

    // アニメーションが終わったらclearStar elementは不要なので削除
    clearStar.addEventListener('animationend', () => {
      clearStar.remove();
    });
    clearStar.addEventListener('webkitAnimationEnd', () => {
      clearStar.remove();
    });

    // スタンプから星がグローバルナビゲーションの獲得星エリアにジャンプする
    let clearStarStyleStr = `top:${clearMissionCardPosPy}px; left:${clearMissionCardPosPx}px;`
    clearStar.setAttribute('style', clearStarStyleStr)
    clearStar.classList.add('add')

    let root = document.querySelector(':root');
    let rootStyleStr = `--top:${(targetPosPy - 10)}px; --left:${(targetPosPx - 50)}px;`
    root.setAttribute("style", rootStyleStr)
  }

  const missionKindSort = computed(() => {
    return MISSIONKIND_SORT
  })

  const missionKindMap = computed(() => {
    return MISSIONKIND_MAP
  })
  const sectionTitle = computed(() => {
    if(selectedSection.value){
      return selectedSection.value.title
    }
    return ""
  })

  const sectionLabel = computed(() => {
    if(selectedSection.value){
      return selectedSection.value.sort_order
    }
    return ""
  })

  const displayName = computed(() => {
    if(questionSet.value){
      return questionSet.value.question_set_label.display_name
    }
    return ""
  })

  function isInterruptionData(card: any):boolean {
    return card.mission_kind === MISSIONKIND_SORT.NEW && workStore.study_break_data[card.work_id]?.break_data?.question_set_id === card.question_set.id
  }

  function missionCard(field){
    if(topStore.missions.subject_field_missions.length > 0){
      if(topStore.missions.subject_field_missions.filter(item => item.subject_field == field).length > 0){
        return topStore.missions.subject_field_missions.filter(item => item.subject_field == field)[0].missions
      }
    }
  }

  function clearMissionNumber(question_set_id){
    let result = topStore.questionSetProgress.filter(qs => qs.id == question_set_id)
    if(result.length > 0){
      return result[0].done_correctly_question_ids.length
    }
  }

  function totalMissionNumber(question_set_id){
    let result = topStore.questionSetProgress.filter(qs => qs.id == question_set_id)
    if(result.length > 0){
      return result[0].question_ids.length
    }
  }

  function numberOfStars(question_set_id) {
    let result = topStore.latestQuestionSetHistories.filter(h => h.question_set_id == question_set_id)
    if (result.length > 0) {
      return result[0].number_of_stars
    }
  }

  function previousStudyMonth(question_set_id){
    let result = topStore.latestQuestionSetHistories.filter(h => h.question_set_id == question_set_id)
    if (result.length > 0) {
      let date = result[0].study_start_datetime.substr(5,5)
      let parts = date.split('-')
      return parts[0]
    }
  }

  function previousStudyDay(question_set_id){
    let result = topStore.latestQuestionSetHistories.filter(h => h.question_set_id == question_set_id)
    if (result.length > 0) {
      let date = result[0].study_start_datetime.substr(5,5)
      let parts = date.split('-')
      return parts[1]
    }
  }

  // NFR-2161対応：リロードして表示できるミッションがない場合リロードボタンを表示しない。
  function generateReloadButton(card, subj){
    let isReloadable = topStore.missions.subject_field_missions.filter(item => item.subject_field == subj.field)[0].reloadable
    if(isReloadable && card.mission_kind !== missionKindSort.value.NEW){
      return true
    }
    return false
  }

  // New mission以外は対象。ミッション生成APIを呼び出し
  async function reloadMission(uuid, mission_kind=null, id=null){
    // for disabled reloaded mission card
    let reloadMissionCard: any = {}
    if(id){
      reloadMissionCard = refMission.value[id]
      reloadMissionCard.classList.add('reloadClear')
    }
    if(!workStore.isMissionQuestion){
      if(accountStore.isSoundEnabled){audioPlayer.reloadSound().play()}
    }
    if(isEnvCaptureGoogleAnalyticsEvents() && mission_kind){
      event('recreate_mission', {
          'mission_kind': mission_kind
      })
    }
    await topStore.fetchGenerateMissionList({recreate: uuid})
    let question_set_ids = nestedItems(topStore.missions, "subject_field_missions[].missions[].question_set.id")
    topStore.saveQuestionSetIds(question_set_ids)
    await topStore.fetchLatestQuestionSetHistories({'question_set_ids': question_set_ids})
    await topStore.fetchMissionQuestionSetProgress({'question_set_ids': question_set_ids})
    // fetching sections if reload button press
    if(uuid){
      const sectionData =  findSectionByQuestionSetId(workStore.works,question_set_ids)
      workStore.saveSections(sectionData)
    }
    // enabled mission card
    if(id){
      reloadMissionCard.classList.remove('reloadClear')
    }
  }

  function sectionInfo(mission) {
    let info = {
      section_sort_order: "",
      section_title: "",
      display_name: ""
    }
    if (workStore.sections.length > 0) {
      for (let section of workStore.sections) {
        for (let item of section.question_sets) {
          if (item.id === mission.question_set.id) {
            info = {
              section_sort_order: section.sort_order.toString(),
              section_title: section.title,
              display_name: item.question_set_label.display_name
            }
            return info
          }
        }
      }
    }
    return info
  }

  // ボタングループからボタンを押す時表示されるミッション（社会の場合：地理、歴史、公民どちらが表示）
  function isSelected(subject) {
    topStore.saveCurrentMission(subject)
  }

  // 教科分野ごとにイメージを変更 　
  function subjectImage(subj){
    return SUBJECTFIELD_ID_IMAGE_MAP[subj]
  }

  // カルーセルボタンを押したり、ボタングループのボタンを押したりするときミッション表示制御
  function missionDisplay(subject){
    if(topStore.currentMission == subject){
      return { '--mission-display': 'block'}
    }
    return { '--mission-display': 'none'}
  }

  // カルーセルの右、左ボタンを押すと実行
  function moveCarousel(subj, way){
    if(accountStore.isSoundEnabled){audioPlayer.buttonSound().play()}
    for(let i = 0; i < topStore.carouselSubject.length; i++){
      if (subjectFieldMap[topStore.carouselSubject[i].field] == subjectFieldMap[subj.field]) {
        if (way == "next") {
          if (topStore.carouselSubject[i + 1]) {
            topStore.saveCurrentMission(subjectFieldMap[topStore.carouselSubject[i + 1].field])
          } else {
            topStore.saveCurrentMission(subjectFieldMap[topStore.carouselSubject[0].field])
          }
        } else if (way == "prev") {
          if (topStore.carouselSubject[i - 1]){
            topStore.saveCurrentMission(subjectFieldMap[topStore.carouselSubject[i - 1].field])
          }else{
            topStore.saveCurrentMission(subjectFieldMap[topStore.carouselSubject[topStore.carouselSubject.length-1].field])
          }
        }
      }
    }
  }
  async function startInterruptDataLearning(){
    await openQuestionModal(interruptionFlag.value.card, interruptionFlag.value.card_id, false, true)
    startLearning(true)
    
  }
  function openInterruptionModal(card, card_id) {
    interruptionFlag.value.card = card
    interruptionFlag.value.card_id = card_id
    interruptionModal.value = true
  }
  async function openQuestionModal(mission, id, isQuestionModal = true,  isInterrupt = false){
    interruptionModal.value = isInterrupt
    if(accountStore.isSoundEnabled && isQuestionModal){audioPlayer.startSound().play()}
    let current_work_index: number = 0
    processing.value = true
    topStore.saveCardId(id)
    let work = workStore.works.filter(item => subjectFieldMap[item.subject_field] == topStore.currentMission)
    // NFR-3959対応 選択した教科分野のワークをtextbook.academic_yearに降順ソートする
    let work_by_academic_year = work.sort(function(a,b){
      return (a["academic_year"] > b["academic_year"]) ? -1: 1
    })
    workStore.saveSelectedWork(work_by_academic_year)
    // NFR-3959対応 降順ソートしたworkでprofileのreal_academic_yearと一致するものがあればそのwork indexを返す。
    for(let i = 0 ; i < work_by_academic_year.length; i++){
      if(work_by_academic_year[i].academic_year == accountStore.realAcademicYear){
        current_work_index = i
        break;
      }
    }
    workStore.saveSelectedWorkIndex(current_work_index)
    workStore.saveMission({uuid: mission.uuid, kind: mission.mission_kind})
    questionModal.value = isQuestionModal
    if(shakaiSubMap.value.includes(topStore.currentMission)){
      globalNavigationStore.saveSelectedColor("shakai")
    }else{
      globalNavigationStore.saveSelectedColor(topStore.currentMission)
    }
    selectedQuestionSet.value = mission.question_set
    stars.value = numberOfStars(selectedQuestionSet.value.id)
    if(mission.question_ids?.length){
      await workStore.fetchQuestions({"question_ids": mission.question_ids})
      workStore.saveTotalNumOfQuestion(workStore.questionIds.length)
    }else{
      await workStore.fetchQuestions({"question_set_id": selectedQuestionSet.value.id})
      workStore.saveTotalNumOfQuestion(workStore.questionIds.length)
    }
    // NFR-2811)chapter画面から問題を解いてtop画面に戻って再ロードしてチャレンジモーダルを開くと問題数が全体小問数になっている。
    // chapter画面からtopに戻った時missionのquestion_idsはnullなので該当する出題単位の小問を全部取得してstateに保存されてる。
    let qs_progress = topStore.questionSetProgress.filter(qs => qs.id == mission.question_set.id)
    let questions: any = []
    let question_ids: any = []
    if(qs_progress.length){
      workStore.questions.forEach(item=>{
        if(!qs_progress[0].done_correctly_question_ids.includes(item.id)){
          questions.push(item)
          question_ids.push(item.id)
        }
      })
    }
    if(questions.length > 0){
      workStore.saveQuestions(questions)
      workStore.saveQuestionIds(question_ids)
    }else{
      workStore.saveQuestions(workStore.questions)
      workStore.saveQuestionIds(workStore.questionIds)
    }
    selectedSection.value = null
    questionSet.value = null
    for(let section of workStore.sections){
      for(let item of section.question_sets){
        if(item.id==selectedQuestionSet.value.id){
          selectedSection.value = section
          selectedSection.value.textbook_page_range = selectedQuestionSet.value.textbook_page_range
          questionSet.value = item
          break
        }
      }
      if(selectedSection.value){
        break
      }
    }
    workStore.saveSelectedQuestionSet({[selectedQuestionSet.value.id]:questionSet.value})
    processing.value = false
  }
  function closeModal(){
    if(processing.value){
      return
    }
    if(accountStore.isSoundEnabled){audioPlayer.closeSound().play()}
    questionModal.value = false
  }
  function closeLayer(){
    if(processing.value){
      return
    }
    questionModal.value = false
  }
  function startLearning(isInterrupt=false){
    if(processing.value || isAnimationStarCount.value){
      return
    }
    workStore.saveQIdx(0)
    if(workStore.questionIds.length>0){
      if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
      workStore.saveIsLearningPage(true)
      workStore.saveIsLearningMode(true)
      workStore.saveIsMissionQuestion(true)
      workStore.saveIsReviewQuestion(false)
      workStore.saveIsUnanswered(false)
      workStore.saveIsWronglyAnswered(false)
      workStore.saveLearningStartPage(learningStartPage)
      let questionCorrectWrongList = workStore.questionIds.map((item) => {
        return {
          result: null,
          progress: 0
        }
      })
      workStore.fetchReviewTag({"question_set_id": selectedQuestionSet.value.id})
      workStore.fetchQuestionProgress({question_ids: workStore.questionIds})
      workStore.initializeAnswer()
      workStore.saveNextQuestionSet(null)
      // NFR-5524: start last interruption
      if(isInterrupt){
        // NFR-5868: getting the interruption data
        const break_data = workStore.study_break_data[interruptionFlag.value.card.work_id]?.break_data
        workStore.saveIsWronglyAnswered(true)
        questionCorrectWrongList = break_data?.correct_wrong_list
        // NFR-5868: ensure to save initialAnswer as an array
        workStore.saveInitializeAnswer(break_data?.saved_answers || [])
        // NFR-5118: getting interruption question index
        const current_question_index = break_data?.interrupt_index
        // NFR-5118: getting the last interrupt path
        const interrupt_path = break_data?.interrupt_path
        workStore.saveQIdx(current_question_index)
        const created_at = break_data?.data_created_at
        const updated_at = local_time()
        // NFR-5116: initilize study break data when resume learning
        saveInitialStudyBreakData(workStore, selectedQuestionSet.value.id, questionCorrectWrongList, created_at, updated_at, null, getLatestBreakDataVersion(), null, current_question_index)
        workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
        router.push({name:`${interrupt_path}`})
      }
      else {
        // NFR-5116: initilize study break data
        saveInitialStudyBreakData(workStore, selectedQuestionSet.value.id, questionCorrectWrongList, local_time(), null, null, getLatestBreakDataVersion(), null)
        workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
        router.push({name:'question'})
      }
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('start_mission', {
          'mission_kind': workStore.learningMission.kind
        })
      }
    }
  }
  async function renderingData(){
    let mission_list
    // ログイン直後、またはTOP画面リロードする時
    if (topStore.currentMission == "") {
        await topStore.fetchRecommendedSubjects()
        // NFR-4133対応：ログイン直後またはTOP画面リロード中他の画面に遷移する時stateが空になってる場合がある。
        // それを防ぐためmission dataがあるstateを使わずにactionのreturn値を使用する。
        mission_list = await topStore.fetchMissionList()

        if (mission_list.subject_field_missions.length == 0) {
            // NFR-5513 2秒後にもselectedMenuが'mission'の場合にfetchGenerateMissionListを呼び出す
            setTimeout(async () => {
                if (globalNavigationStore.selectedMenu === 'mission') {
                    mission_list = await topStore.fetchGenerateMissionList({ recreate: null });
                    // mission_listを使用した後続の処理を実行
                    processMissionList(mission_list);
                }
                // NFR-5513 generate apiが呼び出されてミッション画面表示ができる前までローディング表示
                isMissionPageLoading.value = false
                // NFR-5162 ロードが完了したことを示すイベントを発火
                window.dispatchEvent(new Event('MissionPageLoaded'));
            }, 2000);
        } else {
            // mission_listがすでに存在する場合はそのまま処理を進める
            processMissionList(mission_list);
            isMissionPageLoading.value = false
            window.dispatchEvent(new Event('MissionPageLoaded'));
        }
    }else{
      isMissionPageLoading.value = false
      if(workStore.isMissionQuestion){
        workStore.saveIsMissionQuestion(false)
        isAnimationStarCount.value = true
        await topStore.fetchLatestQuestionSetHistories({'question_set_ids': topStore.questionSetIds})
        await topStore.fetchMissionQuestionSetProgress({'question_set_ids': topStore.questionSetIds})
        let number_of_star = numberOfStars(workStore.questions[0].question_set_id)
        await animateDonutGraph(topStore.cardId, number_of_star)
        // NFR-5149 該当するミッションカードが次のミッションカードが出る前まで非活性化する。
        isMissionCardLoading.value = { ...isMissionCardLoading.value, [topStore.cardId]: true };
        await reloadMission(null)
        // NFR-5149 reloadMission関数が終わった後は次のミッションカードが表示されるのでカードを活性化する。
        isMissionCardLoading.value = { ...isMissionCardLoading.value, [topStore.cardId]: false };
      }
      let question_set_ids = nestedItems(topStore.missions, "subject_field_missions[].missions[].question_set.id")
      if(question_set_ids.length > 0){ // NFR-3151対応（missionsでデータがない場合question_set_idsも空なので値が存在する場合のみsection apiを呼ぶ）
        const sectionData =  findSectionByQuestionSetId(workStore.works,question_set_ids)
        workStore.saveSections(sectionData)
      }else{ // question_set_idsが空の場合sentryにメッセージを送信する
        Sentry.captureMessage(`question_set_ids is None. userId: ${accountStore.userId}`, "log")
      }
    }
  }
  async function processMissionList(mission_list) {
    let carouselSubject = [];

    // NFR-5288 mission_listが存在し、subject_field_missionsが定義されている場合のみループを実行
    if (mission_list && mission_list.subject_field_missions) {
        for (let item of mission_list.subject_field_missions) {
            // sort the correct subject_field order
            if (item.subject_field == SOCIETY_SUBJECT_FIELD.CHIRI || item.subject_field == SOCIETY_SUBJECT_FIELD.KOMIN || item.subject_field == SOCIETY_SUBJECT_FIELD.REKISHI) {
                carouselSubject[SUBJECTFIELD_ORDER_MAP[item.subject_field]] = { name: "社会", field: item.subject_field };
            } else {
                carouselSubject[SUBJECTFIELD_ORDER_MAP[item.subject_field]] = { name: item.subject_field, field: item.subject_field };
            }
        }
    }

    // delete null item from carousel subject
    carouselSubject = carouselSubject.filter(item => item != null);
    topStore.saveCarouselSubject(carouselSubject);
    if (topStore.currentMission == "" && carouselSubject.length) {
        topStore.saveCurrentMission(subjectFieldMap[carouselSubject[0].field]);
    }

    // NFR-5288 mission_listが存在する場合のみnestedItems関数を使用してquestion_set_idsを取得、存在しない場合は空配列を設定
    let question_set_ids = mission_list ? nestedItems(mission_list, "subject_field_missions[].missions[].question_set.id") : [];
    if (question_set_ids.length > 0) { // NFR-3151対応
        topStore.saveQuestionSetIds(question_set_ids);
        await topStore.fetchLatestQuestionSetHistories({ 'question_set_ids': question_set_ids });
        await topStore.fetchMissionQuestionSetProgress({ 'question_set_ids': question_set_ids });
        const sectionData = findSectionByQuestionSetId(workStore.works, question_set_ids);
        workStore.saveSections(sectionData);
    } else {
        Sentry.captureMessage(`question_set_ids is None. userId: ${accountStore.userId}`, "log");
    }
  }  
  watch(
    () => workStore.works,
    (newVal) => {
      // NFR-4440 ワーク/ワークAPIの値を監視してある場合のみ画面レンダリングで必要な処理を行う。
      if(newVal){
        renderingData()
      }
    }
  )
  onUnmounted(() => {
    window.removeEventListener('popstate', browserBackHandler);
    if(isAnimationStarCount.value){
      reloadMission(null)
      workStore.saveIsMissionQuestion(false)
      globalNavigationStore.fetchNavAccountStatus(null)
      for(let i in refresh_timer.value){
        clearTimeout(refresh_timer.value[i])
      }
    }
  })
</script>